import * as types from "./mutation_types"

export default {
    [types.RESET](state) {
        Object.assign(state, {
            filter: {},
            isLoading: false,
            items: [],
            showMessage: false,
            message: "",
            isSuccess: false,
            currentItem: null,
            pagination: null,
            raisons: [],
            options: [],
        })
    },
    [types.SET_RAISONS](state,raisons) {
        Object.assign(state, { raisons })
    },
    [types.SET_OPTIONS](state, options) {
        Object.assign(state, { options })
    },
    [types.SET_TOGGLE_LOADING](state) {
        Object.assign(state, { isLoading: !state.isLoading })
    },
    [types.SET_PAGINATION](state, pagination) {
        Object.assign(state, { pagination })
    },
    [types.SET_SHOW_LOADING](state) {
        Object.assign(state, { isLoading: true })
    },
    [types.SET_HIDE_LOADING](state) {
        Object.assign(state, { isLoading: false })
    },
    [types.SET_TOGGLE_MESSAGE](state) {
        Object.assign(state, { showMessage: !state.showMessage })
    },
    [types.SET_SHOW_MESSAGE](state) {
        Object.assign(state, { showMessage: true })
    },
    [types.SET_HIDE_MESSAGE](state) {
        Object.assign(state, { showMessage: false })
    },

    [types.SET_IS_SUCCESS](state) {
        Object.assign(state, { isSuccess: true })
    },
    [types.SET_IS_ERROR](state) {
        Object.assign(state, { isSuccess: false })
    },
    [types.SET_MESSAGE](state, message) {
        Object.assign(state, { message })
    },
    [types.SET_ITEMS](state, items) {
        Object.assign(state, { items })
    },
    [types.SET_APPEND_ITEMS](state, items) {
        Object.assign(state, { items: [...state.items, ...items] })
    },
    [types.SET_CURRENT_ITEM](state, currentItem) {
        Object.assign(state, { currentItem })
    },
}